import { useMemo } from 'react';

import {
  computeAvailability,
  type UseAvailabilityParams,
  type UseAvailabilityResult,
} from '@didaskill/domain/gamification/shared';

/**
 * React hook wrapper
 */
export const useAvailability = ({
  accessStartDate,
  availability,
}: UseAvailabilityParams): UseAvailabilityResult => {
  return useMemo(
    () => computeAvailability(accessStartDate, availability),
    [availability, accessStartDate],
  );
};
